import type { DemoProduct } from "@a/demoRequests";
import { DemoRequestForm } from "@c/shared/DemoRequestForm";
// Direct import (not the @c/shared barrel) — the barrel exports BookDemoButton,
// which imports this modal, closing a 3-file import cycle.
import { ResponsiveModal } from "@ui/responsive-modal";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { conceptIcon } from "@u/conceptIcons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface DemoRequestModalProps {
  /** Which landing opened the form — 'home' | '360' | 'tap'. */
  source?: string;
  /** Preselect the product of interest based on the landing. */
  product?: DemoProduct;
}

const DemoRequestModal = NiceModal.create(function DemoRequestModal({
  source,
  product = "360",
}: DemoRequestModalProps) {
  const modal = useModal();
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  const title = success ? t("demo_success_title") : t("demo_modal_title");
  const titleNode = (
    <span className="flex items-center gap-2">
      <conceptIcon.bookDemo size={20} className="text-primary" />
      {title}
    </span>
  );

  return (
    <ResponsiveModal
      open={modal.visible}
      onOpenChange={(open) => {
        if (!open) modal.hide();
      }}
      title={title}
      titleNode={titleNode}
      size="lg"
    >
      <DemoRequestForm
        source={source}
        product={product}
        onCancel={success ? undefined : () => modal.hide()}
        onSuccessChange={setSuccess}
      />
    </ResponsiveModal>
  );
});

export default DemoRequestModal;
